import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var DEFAULT_SIZE = 889;
var useIsSmallScreen = function useIsSmallScreen() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      size: DEFAULT_SIZE
    },
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? DEFAULT_SIZE : _ref$size;
  var _useState = useState(function () {
      return window.matchMedia("(max-width: ".concat(size, "px)")).matches;
    }),
    _useState2 = _slicedToArray(_useState, 2),
    isMobileView = _useState2[0],
    setIsMobileView = _useState2[1];
  useEffect(function () {
    var handleWindowResize = function handleWindowResize() {
      setIsMobileView(window.matchMedia("(max-width: ".concat(size, "px)")).matches);
    };
    window.addEventListener('resize', handleWindowResize);
    return function () {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [size]);
  return [isMobileView];
};

export { useIsSmallScreen as default };
